import styled, { css, keyframes } from 'styled-components';

const fadeIn = props => css`
  ${keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `}
`;

const AccordionWrapper = styled.div`
  margin: ${props => (props.margin ? props.margin : '5%')};
`;

const ArrowImg = styled.img`
  width: 0.8em;
  height: auto;
  padding-right: ${({ isDesktop }) => (isDesktop ? '2%' : '3%')};
`;

const Heading = styled.div`
  color: #000;
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-size: ${({ isDesktop }) => (isDesktop ? '13px' : '15px')};
  padding-bottom: 4%;
  user-select: none;
`;

const Description = styled.div`
  color: #000;
  animation: ${({ isDesktop }) => (isDesktop ? null : `${fadeIn} 0.5s ease-in-out 1}`)};
  font-family: 'Avenir Light', 'Arial', sans-serif;
  font-size: 13px;
  padding: ${({ isDesktop }) => (isDesktop ? '0 0 0 20px' : '0 0 0 2vw')};
  text-align: ${({ isDesktop }) => (isDesktop ? null : 'justify')};
  /*user-select: none;*/
  & > ul {
    margin: 0;
  }
  a {
    text-decoration: underline;
  }
`;

const AccordionContent = styled.div`
  max-height: ${({ visible }) => (visible ? '100vh' : '0')};
  position: relative;
  overflow: hidden;
  transition: max-height 0.5s ${({ visible }) => (visible ? 'ease-in' : 'ease-out')};
`;

export { AccordionContent, AccordionWrapper, ArrowImg, Description, Heading };
